import { useTranslation } from 'react-i18next';
import Icon from './ui/Icon';

// Google Calendar booking page for a guided setup call with the AeroChat team.
const BOOKING_URL = 'https://calendar.app.google/rHQakysRG5mBK8vA9';

// Shell banner shown under the header on every page while onboarding is
// incomplete. AdminApp owns visibility — the same "onboarding complete" flag
// that hides the Get Started nav item — and holds back the AnnouncementBar
// while this is on screen. Not dismissible: it goes away when setup is done.
export default function SetupHelpBanner() {
  const { t } = useTranslation('common');

  return (
    <div className="setup-help-banner" role="region" aria-label={t('setupHelp.region')}>
      <Icon name="info" className="setup-help-banner__icon" />
      <span className="setup-help-banner__text">
        <strong>{t('setupHelp.title')}</strong> {t('setupHelp.message')}
      </span>
      <a
        className="setup-help-banner__cta"
        href={BOOKING_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('setupHelp.cta')}
      </a>
    </div>
  );
}
